(() => {
  if (window.__liaPdp3Loaded) return;
  window.__liaPdp3Loaded = true;

  const initRoot = (root) => {
    if (!root || root.dataset.pdpInitialized === 'true') return;
    root.dataset.pdpInitialized = 'true';

    const form = root.querySelector('[data-pdp-form]');
    const variantInput = root.querySelector('[data-variant-id-input]');
    const variantJson = root.querySelector('[data-product-variants]');
    const variantMap = root.querySelector('[data-variant-display-map]');
    const radios = Array.from(root.querySelectorAll('[data-option-value]'));
    const primaryButton = root.querySelector('[data-primary-atc]');
    const stickyButton = root.querySelector('[data-sticky-submit]');
    const stock = root.querySelector('[data-stock]');
    const stockText = root.querySelector('[data-stock-text]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const gallery = root.querySelector('[data-pdp-gallery]');
    const counter = root.querySelector('[data-pdp-counter]');
    const mediaItems = Array.from(root.querySelectorAll('[data-pdp-media-item]'));
    const sticky = root.querySelector('[data-pdp-sticky]');

    if (!form || !variantInput || !variantJson || !variantMap) return;

    let variants = [];
    try {
      variants = JSON.parse(variantJson.textContent || '[]');
    } catch (error) {
      return;
    }

    variantInput.disabled = false;
    let adding = false;
    const track = (name, detail = {}) => window.LiadoraTelemetry?.(name, {
      product_id: root.dataset.productId,
      product_title: root.dataset.productTitle,
      item_category: root.dataset.productCategory,
      ...detail
    });
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.LiadoraCart) return;
      event.preventDefault();
      if (adding || primaryButton.disabled) return;
      const error = root.querySelector('[data-product-error]');
      adding = true;
      if (error) error.textContent = '';
      primaryButton.disabled = true;
      if (stickyButton) stickyButton.disabled = true;
      primaryButton.setAttribute('aria-busy', 'true');
      try {
        const path = (document.documentElement.dataset.liaRoot || '/').replace(/\/?$/, '/');
        const response = await fetch(`${path}cart/add.js`, {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || 'Ürün sepete eklenemedi.');
        const addedQuantity = Number(new FormData(form).get('quantity') || 1);
        track('add_to_cart', {variant_id: item.variant_id || item.id, value: (item.final_price ?? item.price) * addedQuantity, quantity: addedQuantity});
        await window.LiadoraCart.refresh(true, primaryButton);
      } catch (failure) {
        if (error) error.textContent = failure.message || 'Ürün sepete eklenemedi.';
      } finally {
        adding = false;
        primaryButton.removeAttribute('aria-busy');
        syncFromOptions({updateUrl: false, moveMedia: false});
      }
    });


    const getSelectedOptions = () => {
      const selected = [];
      root.querySelectorAll('[data-option-position]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        const checked = group.querySelector('[data-option-value]:checked');
        selected[index] = checked ? checked.value : '';
      });
      return selected;
    };

    const getDisplayOption = (variantId) => Array.from(variantMap.options).find((option) => option.value === String(variantId));

    const updateOptionAvailability = (selected) => {
      radios.forEach((radio) => {
        const optionIndex = Number(radio.dataset.optionIndex);
        const possible = variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((optionValue, index) => {
            if (index === optionIndex) return optionValue === radio.value;
            if (!selected[index]) return true;
            return optionValue === selected[index];
          });
        });
        radio.disabled = !possible && !radio.checked;
      });
    };

    const updateCurrentOptionLabels = () => {
      root.querySelectorAll('[data-option-position]').forEach((group) => {
        const checked = group.querySelector('[data-option-value]:checked');
        const current = root.querySelector(`[data-option-current="${group.dataset.optionPosition}"]`);
        if (current) current.textContent = checked ? checked.value : '';
      });
    };

    const moveToVariantMedia = (displayOption) => {
      if (!displayOption || !gallery || window.matchMedia('(min-width: 1100px)').matches) return;
      const mediaId = displayOption.dataset.mediaId;
      if (!mediaId) return;
      const target = root.querySelector(`[data-pdp-media-item][data-media-id="${mediaId}"]`);
      if (!target) return;
      gallery.scrollTo({
        left: target.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    const updateVariantUi = (variant, options = {}) => {
      const displayOption = variant ? getDisplayOption(variant.id) : null;
      const available = Boolean(variant && variant.available);
      const priceText = displayOption ? displayOption.dataset.price : '';
      const compareText = displayOption ? displayOption.dataset.compare : '';
      const variantTitle = displayOption ? displayOption.dataset.title : '';

      if (variant) variantInput.value = variant.id;
      if (price && priceText) price.textContent = priceText;

      if (compare) {
        compare.textContent = compareText || '';
        compare.hidden = !compareText;
      }

      if (stock) stock.dataset.state = variant ? (available ? 'available' : 'soldout') : 'unavailable';
      if (stockText) {
        stockText.textContent = variant
          ? (available ? stockText.dataset.availableText || 'Stokta' : stockText.dataset.soldoutText || 'Tükendi')
          : stockText.dataset.unavailableText || 'Bu kombinasyon mevcut değil';
      }

      const primaryText = variant
        ? (available ? `${root.dataset.addToCartText || 'Sepete Ekle'}${priceText ? ` — ${priceText}` : ''}` : root.dataset.soldoutText || 'Tükendi')
        : root.dataset.unavailableText || 'Mevcut değil';
      const stickyText = variant
        ? (available ? root.dataset.addToCartText || 'Sepete Ekle' : root.dataset.soldoutText || 'Tükendi')
        : root.dataset.unavailableText || 'Mevcut değil';

      if (primaryButton) {
        primaryButton.disabled = !available;
        primaryButton.textContent = primaryText;
      }
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = stickyText;
      }

      root.querySelectorAll('[data-selected-variant]').forEach((node) => { node.textContent = variantTitle || ''; });

      if (variant && options.updateUrl !== false) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variant && options.moveMedia !== false) moveToVariantMedia(displayOption);
    };

    const syncFromOptions = (options = {}) => {
      const selected = getSelectedOptions();
      updateOptionAvailability(selected);
      updateCurrentOptionLabels();
      const variant = radios.length ? variants.find((item) => item.options.every((value, index) => value === selected[index])) : variants.find(item => String(item.id) === variantInput.value) || variants.find(item => item.available) || variants[0];
      updateVariantUi(variant || null, options);
    };

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-value]')) return;
      if (!adding) {
        syncFromOptions();
        const variant = variants.find(item => String(item.id) === variantInput.value);
        track('variant_change', {variant_id: variant?.id, value: variant?.price || 0});
      }
    });

    if (gallery && counter && mediaItems.length > 1) {
      let frame = null;
      const updateCounter = () => {
        frame = null;
        const left = gallery.scrollLeft;
        let index = 0;
        let distance = Number.POSITIVE_INFINITY;
        mediaItems.forEach((item, itemIndex) => {
          const nextDistance = Math.abs(item.offsetLeft - left);
          if (nextDistance < distance) {
            distance = nextDistance;
            index = itemIndex;
          }
        });
        counter.textContent = `${index + 1} / ${mediaItems.length}`;
      };
      gallery.addEventListener('scroll', () => {
        if (frame) return;
        frame = window.requestAnimationFrame(updateCounter);
      }, { passive: true });
    }

    if (sticky && primaryButton && 'IntersectionObserver' in window) {
      let primaryVisible = true;
      let sectionVisible = true;
      const syncSticky = () => sticky.classList.toggle('is-visible', sectionVisible && !primaryVisible);
      const primaryObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { primaryVisible = entry.isIntersecting; syncSticky(); });
      }, { threshold: 0.08 });
      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { sectionVisible = entry.isIntersecting; syncSticky(); });
      }, { threshold: 0 });
      primaryObserver.observe(primaryButton);
      sectionObserver.observe(root);
    }

    syncFromOptions({ updateUrl: false, moveMedia: false });
    const initialVariant = variants.find(v => String(v.id) === variantInput.value);
    track('view_item', {variant_id: initialVariant?.id, value: initialVariant?.price || 0});
  };

  const initAll = (scope) => {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-lia-pdp3]')) initRoot(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-lia-pdp3]').forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

